import React, { useState, useEffect } from "react";
import { useTheme } from "../../CommonComponents/ThemeProvider";
import axios from "axios";
import { showSuccessToast, showErrorToast } from "../../../utils/toast";

export default function AddBranchModal({ isOpen, onClose, onBranchAdded, initialData = null, isEditMode = false }) {
    const [name, setName] = useState("");
    const [location, setLocation] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        if (isOpen && isEditMode && initialData) {
            setName(initialData.name || "");
            setLocation(initialData.location || "");
        } else if (isOpen && !isEditMode) {
            setName("");
            setLocation("");
        }
    }, [isOpen, isEditMode, initialData]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        try {
            const token = sessionStorage.getItem("token");
            const backendUrl = process.env.REACT_APP_API_URL;
            const url = isEditMode && initialData?.id
                ? `${backendUrl}/api/admin/branches/${initialData.id}`
                : `${backendUrl}/api/admin/branches`;
            const method = isEditMode ? "put" : "post";
            const res = await axios[method](
                url,
                { name, location },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            if (onBranchAdded) onBranchAdded(res.data);
            showSuccessToast(isEditMode ? "Branch updated successfully." : "Branch added successfully.");
            setName("");
            setLocation("");
            onClose();
        } catch (err) {
            const errorMessage = err.response?.data?.message || (isEditMode ? "Failed to update branch" : "Failed to add branch");
            setError(errorMessage);
            showErrorToast(errorMessage);
        }
        setLoading(false);
    };

    const { currentTheme } = useTheme();
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
            <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md flex flex-col items-center">
                <h2 className="text-xl font-bold mb-4 text-center">{isEditMode ? "Edit Branch" : "Add Branch"}</h2>
                <form onSubmit={handleSubmit} className="space-y-4 w-full">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Branch Name</label>
                        <input
                            type="text"
                            value={name}
                            onChange={e => setName(e.target.value)}
                            required
                            className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-primary"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Location</label>
                        <input
                            type="text"
                            value={location}
                            onChange={e => setLocation(e.target.value)}
                            className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-primary"
                        />
                    </div>
                    {error && <div className="text-red-500 text-sm text-center">{error}</div>}
                    <div className="flex justify-center gap-2">
                        <button type="button" onClick={onClose} className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300">Cancel</button>
                        <button
                            type="submit"
                            disabled={loading}
                            className="px-4 py-2 rounded text-white disabled:opacity-50"
                            style={{ backgroundColor: currentTheme.color }}
                        >
                            {loading ? (isEditMode ? "Updating..." : "Adding...") : (isEditMode ? "Update Branch" : "Add Branch")}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
